import { useState, useEffect } from 'react';

interface CountdownResult {
  minutes: number;
  seconds: number;
}

function useCountdown(initialDuration: number): CountdownResult {
  const [duration, setDuration] = useState(initialDuration);
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft(prevTimeLeft => prevTimeLeft - 1);
      }, 1000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [timeLeft]);

  useEffect(() => {
    setDuration(initialDuration);
    setTimeLeft(initialDuration);
  }, [initialDuration]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return { minutes, seconds };
}

export default useCountdown;
